import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import FloatingVue, { floatingVueConfig } from '@/plugins/floatingVue';
import { useProductListFiltersStore } from '@/stores/productListFilters';
import { IS_DEV_GATEWAY } from '@/constants/environment';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const embeds = Array.from(document.querySelectorAll('[data-app-embed]'));

const pageSearchBarVisible = embeds.some((el) => {
  const variant = el.getAttribute('data-variant');
  if (variant === 'search-widget-connected') return true;
  if (variant === 'product-list') return el.getAttribute('data-show-search-bar') !== 'false';
  return false;
});
const pageFiltersVisible = embeds.some((el) => {
  const variant = el.getAttribute('data-variant');
  if (variant === 'product-list') return el.getAttribute('data-show-filters') !== 'false';
  return false;
});

useProductListFiltersStore(pinia).setPageVisibility({
  pageSearchBarVisible,
  pageFiltersVisible,
});

const apps = embeds.map((el) => {
  const variant = el.getAttribute('data-variant') || 'default';
  const targetUrl = el.getAttribute('data-target-url') || undefined;
  const showSearchBar = el.getAttribute('data-show-search-bar') !== 'false';
  const showFilters = el.getAttribute('data-show-filters') !== 'false';
  const app = createApp(App, { variant, targetUrl, showSearchBar, showFilters });
  return { app, el };
});

if (apps.length > 0) {
  Sentry.init({
    app: apps.map(({ app }) => app),
    dsn: 'https://4833e6630db19e76908cbc2c070372f9@o4510319226978304.ingest.de.sentry.io/4510319229272144',
    sendDefaultPii: false,
    environment:
      import.meta.env.VITE_APP_ENV ?? (import.meta.env.DEV ? 'development' : 'production'),
    tracesSampleRate: IS_DEV_GATEWAY ? 1.0 : 0.1,
  });
}

apps.forEach(({ app, el }) => {
  app.use(pinia);
  app.use(FloatingVue, floatingVueConfig);
  app.mount(el);
});
